/* eslint-disable quote-props */

// Direct trade B for A.
const replacers = {
    "assoc. ": "Associate",
    "assoc ": "Associate",
    "mgr. ": "Manager",
    "mgr ": "Manager",
    "part-time": "part time",
    "full-time": "full time",
    "sr.": "Senior",
    "jr.": "Junior",
};

// Completely remove.
const individualChars = [
    "sign on",
    "sign-on",
    "bonus",
    "\"",
    "/",
    "*",
    "!",
    "%",
    "&",
    "+",
    ":",
    "$",
    "#",
    "|",
    "@",
    " . "
];

// Completely remove plus anything after.
const removeAfterChars = [
    " at ",
    " per hour ",
    " in ",
    " -",
    "(",
    "[",
    "{",
    "\\",
    ";",
    " | ",
    ",",
    "- "
];

/**
 * Escape characters for special string regex.
 */
const escape = (x: string) => x.replace(/[-[\]{}()/*+?.,\\^$|#\s]/g, "\\$&");

/**
 * Encode then double decode to remove any special characters
 */
const removeEncoding = (title: string) => {
    let result = decodeURIComponent(encodeURIComponent(title));
    try {
        result = decodeURIComponent(result);
    } catch (e) {
        // do nothing its not encoded.
    }
    return result;
};

/**
 * Remove all HTML tags
 */
const removeHTML = (title: string) => title.replace(/(<([^>]+)>)/ig, "").trim();

/**
 * Remove strings wrapped in braces.
 */
const removeBraceWrapped = (title: string) => title.replace(/\{.+?\}/ig, "").trim();

/**
 * Remove strings wrapped in brackets.
 */
const removeBracketWrapped = (title: string) => title.replace(/\[.+?\]/ig, "").trim();

/**
 * Remove strings wrapped in parentheses.
 */
const removeParenthesesWrapped = (title: string) => title.replace(/\(.+?\)/ig, "").trim();

/**
 * Assume this character / string and everything after it is junk.
 */
const removeAfter = (title: string) => removeAfterChars.reduce((prev, curr) => {
    const re = new RegExp(escape(curr), "ig");
    return prev.split(re)[0];
}, title);

/**
 * Replace specific characters or phrases.
 */
const replaceMap = (title: string) => Object.keys(replacers).reduce((prev, curr) => {
    const re = new RegExp(escape(curr), "ig");
    return prev.replace(re, replacers[curr]);
}, title);

/**
 * Replace individual groupings with a space.
 */
const removeIndividual = (title: string) => individualChars.reduce((prev, curr) => {
    const re = new RegExp(escape(curr), "ig");
    return prev.replace(re, " ");
}, title);

/**
 * Remove roman numerals.
 */
const removeRomanNumerals = (title: string) => title.replace(/\b(VI|V|IV|III|II|I)\b/, " ");

/**
 * Remove html encoded entities.
 */
const removeHtmlEntities = (title: string) => title.replace(/&nbsp;|&apos;|&quot;|&gt;|&lt;|&amp;/ig, " ");

/**
 * Remove things that look like time.
 * * 0|01 - 24 hours
 * * followed by colon
 * * followed by 00-59
 * * followed by am or pm.
 */
const removeTime = (title: string) => title.replace(/((?:\d|[01]\d|2[0-3]):[0-5]\d?([AP]M))/ig, " ");

/**
 * Remove strings that look like money.
 */
const removeMoney = (title: string) => title.replace(/(\$?\d+,?\d+\.?\d+k?)|/ig, "");

/**
 * Removes anything at the end of the string that is not a letter.
 * Should be run last.
 */
const clearLastSymbol = (title: string) => title.replace(/[^A-Z]+$/ig, "");

/**
 * Removes anything at the begining of the string that is a symbol.
 * Should be run last.
 */
const clearFirstSymbol = (title: string) => title.replace(/^[\W_]+/ig, "");

/**
 * Removes leading standalone numbers followed by a space
 * Should be run in group 3.
 */
const clearLeadingNumbers = (title: string) => title.replace(/^[\d\s-/]+\s/, "");

/**
 * Remove multiple whitespace characters including tab space linefeed backspace...
 */
const removeContiguousWhiteSpace = (title: string) => title.replace(/\s+/g, " ").trim();

/**
 * Loop through each replacers, trimming after each pass.
 */
const titleNormalization = (title: string) => {
    const starter = title.trim();
    const operations = [
        // # Round 1 Rules.  These cleanup the characters for the rest of the replacers.
        removeEncoding,
        removeHTML,
        removeHtmlEntities,
        removeBraceWrapped,
        removeBracketWrapped,
        removeParenthesesWrapped,
        // # Round 2 Rules.  These start removing huge chunks of text.
        replaceMap,
        removeMoney,
        removeTime,
        removeAfter,
        removeIndividual,
        removeRomanNumerals,
        // # Round 3 Rules.  These come near the end as numbers and such could get pushed to the edges.
        clearLastSymbol,
        clearFirstSymbol,
        clearLeadingNumbers,
        // # Round 4 Rule. Dead last to cleanup the whitespace.
        removeContiguousWhiteSpace,
    ];
    const result = operations.reduce((prev, curr) => curr.call(undefined, prev).trim(), starter);
    return result.trim();
};

export {
    removeAfterChars,
    individualChars,
    replacers,
    titleNormalization
};
